import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './components/redux/store';
import HomePage from './components/HomePage/HomePage';
import UserDetails from './components/UserDetails/UserDetails';
import QuestionairePart1 from './components/Quetionaire/QuetionairePart1';
import QuestionairePart2 from './components/Quetionaire/QuestionairePart2';
import FinalOutput from './components/FinalOutput/FinalOutput';
import SignLogIn from './components/HomePage/SignLogIn';
import DashboardComponent from './components/NavBar/DashboardComponent';
import Assesment from "./components/NavBar/Assessment";
import LandingPage from "./components/HomePage/LandingPage";
import PrivacyPolicy from "./components/HomePage/PrivacyPolicy";
import TermsOfService from "./components/HomePage/TermsOfService";
import Entrypage from "./components/LandingPage/Entrypage";
import AccessReport from "./components/LandingPage/AccessReport";

function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Router>
          <Routes>
            <Route path="/" element={<Entrypage />} />
            <Route path="/login" element={<HomePage />} />
            <Route path='/userdetails' element={<UserDetails />} />
            <Route path='/quetionairepart1' element={<QuestionairePart1 />} />
            <Route path='/quetionairepart2' element={<QuestionairePart2 />} />
            <Route path='/finaloutput' element={<FinalOutput />} />
            <Route path='/signlogIn' element={<SignLogIn />} />
            <Route path='/dashboard' element={<DashboardComponent />} />
            <Route path='/assesment' element={<Assesment />} />
            <Route path='/landingpage' element={<LandingPage />} />
            <Route path='/privacypolicy' element={<PrivacyPolicy />} />
            <Route path='/termsofservice' element={<TermsOfService />} />
            <Route path='/accessreport' element={<AccessReport />} />
          </Routes>
        </Router>
      </PersistGate>
    </Provider>
  );
}

export default App;
